import React from 'react';

export interface UseTimerResult {
  isActive: boolean,
  start: VoidFunction,
  stop: VoidFunction,
  reset: VoidFunction,
  seconds: number,
}

const useTimer = (): UseTimerResult => {
  const [seconds, setSeconds] = React.useState(0);
  const [isActive, setIsActive] = React.useState(false);

  const start = React.useCallback(
    () => setIsActive(true),
    [],
  );

  const stop = React.useCallback(
    () => setIsActive(false),
    [],
  );

  const reset = React.useCallback(
    () => {
      stop();
      setSeconds(0);
      setIsActive(false);
    },
    [stop],
  );

  const result = React.useMemo(() => ({
    isActive,
    start,
    stop,
    reset,
    seconds,
  }), [seconds, isActive, stop, start, reset]);

  React.useEffect(() => {
    let interval: number | undefined;

    if (isActive) {
      interval = window.setInterval(() => {
        setSeconds((time) => time + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  return result;
};

export default useTimer;
